export default "__VITE_ASSET__e1GQtyjr__"